import { Injectable } from '@angular/core';
import { ApolloClientService } from './apollo-client.service';
import { map, Observable, of, switchMap, take } from 'rxjs';
import { EeseRequirementDto } from 'src/app/models/dto/eeseRequirementDto';
import { GraphQLEeseResponseOutput } from 'src/app/graphQL/models/output/graphql-eese-response-output';
import { convertGraphqlEeseRequirementToDto } from 'src/app/graphQL/mappers/eese-requirement.mapper';
import { GET_EESE_REQUIREMENT_QUERY } from 'src/app/graphQL/queries/eese-requirement-queries';
import { EeseRequirementRequestInput } from 'src/app/graphQL/models/input/graphql-eese-requirement-input';
import { environment } from 'src/environments/environment';
import { GET_VEHICLE_FUNCTIONS_QUERY } from 'src/app/graphQL/queries/vehicle-functions-queries';
import { EesePollResult } from 'src/app/graphQL/enums/graphql-eese-pool-result-enum';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class EeseRequirementApiService {

  constructor(private apolloClientService: ApolloClientService, private http: HttpClient) {}

  getByNameAndRevision(name: string, revision: number): Observable<EeseRequirementDto>{
    if (environment.IsHero)
      return of(null);

    let input : EeseRequirementRequestInput = {
      Name: name,
      Revision: revision,
      Variant: ''
    }
    return this.apolloClientService.apolloClient$.pipe(
      switchMap(client =>
        client.query<{configuratorEeseGetRequirement : GraphQLEeseResponseOutput}>({
          query: GET_EESE_REQUIREMENT_QUERY,
          variables: {EeseRequirementInput: input}
        })
      ),
      map(result => {
        let requirement = result?.data?.configuratorEeseGetRequirement;
        return convertGraphqlEeseRequirementToDto(requirement);
      })
    )
  }

  getAll(): Observable<EeseRequirementDto[]> {
      if (environment.IsHero)
        return of([]);

      return this.apolloClientService.apolloClient$.pipe(
            take(1),
            switchMap(client => {
              return client.query<{fileHandlerEeseGetDownloadPresignedUrl: string}>({
                query: GET_VEHICLE_FUNCTIONS_QUERY,
                variables: {EeseResultFor: EesePollResult.REQ}
              });
            }),
            map(results => {
              const url = results?.data?.fileHandlerEeseGetDownloadPresignedUrl;
              return url ?? '';
            }),
            switchMap(url => {
              return this.http.get<any[]>(url, { withCredentials: false });
            }),
            map(requirements => {
              const mapped = (requirements ?? []).map(req => ({
                id: req.id,
                name: req.name,
                revision: req.revision,
                variant: req.variant,
                asil: req.asil,
                cyberSecurity: req.cyberSecurity,
              } as EeseRequirementDto));
              return mapped;
            })
          );
    }
}
